import { useTranslation } from 'react-i18next';
import { FieldValues, FormProvider, useForm } from 'react-hook-form';

import Button from '../../../components/shared/Button';
import TextEditor from '../../../components/shared/TextEditor';
import TransitionLoader from '../../../components/shared/TransitionLoader/TransitionLoader';

import { useRegions } from '../../../context/regions-context';

interface InfoFormProps {
  onSubmit: (data: FieldValues) => void;
  defaultValues: { content: string | undefined; regionId: number } | null;
}

const InfoForm: React.FC<InfoFormProps> = ({ onSubmit, defaultValues }) => {
  const { t } = useTranslation();
  const { activeRegion } = useRegions();
  const methods = useForm<FieldValues>({
    defaultValues: {
      content: defaultValues?.content || '',
      regionId: defaultValues?.regionId || activeRegion?.id,
    },
  });

  const {
    handleSubmit,
    watch,
    formState: { isSubmitting },
  } = methods;

  return (
    <>
      {isSubmitting && <TransitionLoader message={t('state.creating')} />}
      <FormProvider {...methods}>
        <form className="pks-layout-col-md" onSubmit={handleSubmit(onSubmit)}>
          <div className="pks-layout-col-md">
            <TextEditor
              label={t('global.description')}
              value={watch('content')}
              onChange={(value) => methods.setValue('content', value)}
            />
          </div>
          <div>
            <Button type="submit">
              {isSubmitting ? t('state.submitting') : t('global.confirm')}
            </Button>
          </div>
        </form>
      </FormProvider>
    </>
  );
};

export default InfoForm;
